import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/Logo";
import { Link } from "react-router-dom";
import { Footer } from "@/components/layout/Footer";
import { MetaTags } from "@/components/seo/MetaTags";

const Cookies = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MetaTags 
        title="Cookie Policy - Ritual"
        description="Learn how Ritual uses cookies and similar technologies to provide a better experience."
      />
      
      <nav className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
        <div className="container flex h-14 sm:h-16 items-center justify-between px-4 sm:px-6">
          <Link to="/">
            <Logo size="sm" />
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm">Back</Button>
          </Link>
        </div>
      </nav>

      <main className="flex-1">
        <div className="container max-w-3xl py-8 sm:py-16 px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Cookie Policy</h1>
          
          <div className="prose prose-gray dark:prose-invert max-w-none space-y-6 text-sm sm:text-base">
            <section>
              <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
              <p>
                This Cookie Policy explains how Ritual ("we", "us", or "our") uses cookies and similar technologies 
                when you visit our website or use our services.
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold mt-8 mb-4">What Are Cookies?</h2>
              <p className="text-muted-foreground">
                Cookies are small text files that are placed on your device when you visit a website. They are widely 
                used to make websites work more efficiently and to provide information to website owners.
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold mt-8 mb-4">How We Use Cookies</h2>
              <p className="text-muted-foreground mb-4">We use cookies for the following purposes:</p>
              
              <h3 className="text-base font-semibold mt-4 mb-2">Essential Cookies</h3>
              <p className="text-muted-foreground">
                These cookies are necessary for the website to function properly. They enable core functionality 
                such as security, authentication, and accessibility. You cannot opt out of these cookies.
              </p>
              
              <h3 className="text-base font-semibold mt-4 mb-2">Performance Cookies</h3>
              <p className="text-muted-foreground">
                These cookies help us understand how visitors interact with our website by collecting and reporting 
                information anonymously. This helps us improve our website.
              </p>
              
              <h3 className="text-base font-semibold mt-4 mb-2">Functional Cookies</h3>
              <p className="text-muted-foreground">
                These cookies enable enhanced functionality and personalization, such as remembering your preferences 
                and settings (e.g., dark mode preference).
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold mt-8 mb-4">Third-Party Cookies</h2>
              <p className="text-muted-foreground">
                We may use third-party services that set cookies on your device. These include analytics services 
                to help us understand how our website is used. Each third party has their own privacy policy.
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold mt-8 mb-4">Managing Cookies</h2>
              <p className="text-muted-foreground">
                Most web browsers allow you to control cookies through their settings. You can typically find these 
                settings in the "Options" or "Preferences" menu of your browser. However, if you disable cookies, 
                some features of our website may not function properly.
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold mt-8 mb-4">Updates to This Policy</h2>
              <p className="text-muted-foreground">
                We may update this Cookie Policy from time to time. We will notify you of any changes by posting 
                the new policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold mt-8 mb-4">Contact Us</h2>
              <p className="text-muted-foreground">
                If you have questions about our use of cookies, please contact us at{" "}
                <a href="mailto:privacy@ritual.app" className="text-primary hover:underline">
                  privacy@ritual.app
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Cookies;
